import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

	state: {
		data: false
	},

	getters: {

		data: function(state) {

			return state.data

		}

	},

	mutations: {

		set: function(state, value) {

			Vue.set(state, 'data', value)

		}

	}

})
